export default __webpack_public_path__ + "static/custom-receipt-editor-7d99d96dc90d89bf45e601a72da6c4a4.png";